"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.search.placeholder': 'Buscar pagos por ID de sesión, descripción, email...',
};
